import { updateConversationAsync } from '../../API/conversations/updateConversationAsync';
import { createAsyncSliceWithDataAndQuery } from '../createAsyncSliceWithDataAndQuery';
import { IConversationData } from '../../types/conversations/IConversation';

export const { slice: saveConversationSlice, asyncAction: saveConversationAction } = createAsyncSliceWithDataAndQuery(
  'saveConversation',
  updateConversationAsync,
  {} as IConversationData
);
